export function isEditorContentEmpty(content: string): boolean {
    const container = document.createElement('div');
    container.innerHTML = content;

    container.querySelectorAll('br').forEach((el) => el.remove());

    let text = container.textContent || '';

    // Trim whitespace and non-breaking spaces
    text = text.replace(/\u00A0/g, ' ').trim();

    return text.length === 0 && container.querySelectorAll('img').length === 0;
}
